export const usps = [
  {
    id: 1,
    title: "Proven Expertise",
    text: "We’re experienced tutors who truly understand the process and bring firsthand insight to every lesson.",
  },
  {
    id: 2,
    title: "Structured and Specialised Curriculum",
    text: "Our curriculum is carefully designed to prepare students for the 11+ exam with clarity, strategy, and consistency – ensuring no gaps, no confusion, and no last-minute panic.",
  },
  {
    id: 3,
    title: "Engaging and Effective Teaching",
    text: "We make learning enjoyable and interactive. Our approach helps students develop strong study habits, deeper understanding, and a healthier relationship with learning that lasts beyond the exam.",
  },
  {
    id: 4,
    title: "Small Class Sizes",
    text: "We intentionally keep our classes small, with no more than four students.  This ensures a healthy balance allowing students to collaborate and motivate one another, while maintaining an excellent student-to-teacher ratio for personalised attention and guidance",
  },
  {
    id: 5,
    title: "A True Partnership",
    text: "Your child’s success is our priority. We offer open communication, consistent feedback, and dedicated support, working alongside your family every step of the way.",
  },
];
